import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { PromocionesService } from '../../services/promociones.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { LfsaBotonsGridComponent } from 'src/app/shared/components/lfsa-botons-grid/lfsa-botons-grid.component';
import { Client } from '../../../portfolio/interfaces/client.interface';

@Component({
  selector: 'app-promocion-clientes',
  templateUrl: './promocion-clientes.component.html',
  styleUrls: ['./promocion-clientes.component.css']
})
export class PromocionClientesComponent implements OnInit {

  gridApi: any;
  gridColumnApi: any;
  columnDefsCondCliente = [];
  frameworkComponents: any;
  rowDataCondCliente: any[] = [];
  verFormularioAgregarCondCliente = false;

  idPromo: string;
  cliente?: any;
  tipoPromo: string;
  desc: string = '';
  clienteModal: Client;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly promocionesService: PromocionesService,
    private readonly _util: UtilsService
  ) {
    this.gridComponent();
  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      const id = params['id'] as string
      if (id) {
        this.idPromo = id;
        this.cargarCondCliente(id);
      }
    });
    this.route.queryParams.subscribe((query) => {
      this.tipoPromo = query['tipo_promo'];
      this.desc = query['desc'];
    })
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  gridComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
      iconButtonRenderer: LfsaBotonsGridComponent
    };

    this.columnDefsCondCliente = [
      {
        headerName: 'Cliente',
        field: 'id_cliente',
        sortable: true,
        filter: true
      },
      {
        headerName: 'Nombre',
        field: 'name_cliente',
        sortable: true,
        filter: true
      },
      {
        headerName: 'Cantidad Máxima',
        field: 'cantidad_maxima',
        sortable: true,
        filter: true
      },
      {
        headerName: 'Control Máximo',
        field: 'control_maximo',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Número Máximo Compras',
        field: 'numero_maximo_compras',
        sortable: true,
        filter: true,
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 80,
        cellStyle: {
          padding: 0
        },
        cellRendererParams: {
          onClick: this.editarCondCliente.bind(this),
          label: 'Editar',
          colorBoton: 'btn btn-info btn-block'
        },
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 80,
        cellStyle: {
          padding: 0
        },
        cellRendererParams: {
          onClick: this.eliminarCondCliente.bind(this),
          label: 'Eliminar',
          colorBoton: 'btn btn-danger btn-block'
        },
      }
    ];
  }

  nuevoCondCliente() {
    this.cliente = undefined;
    this.verFormularioAgregarCondCliente = true;
  }

  editarCondCliente({ rowData }) {
    this.cliente = rowData;
    this.verFormularioAgregarCondCliente = true;
  }

  back() {
    this.verFormularioAgregarCondCliente = false;
    this.cliente = undefined;
  }

  cargarCondCliente(id_promo) {
    this.promocionesService.cargarCondCliente(id_promo.trim()).subscribe(
      (resp) => {
        if (resp) {
          this.rowDataCondCliente = resp;
        } else {
          this.rowDataCondCliente = [];
        }
      },
      (error) => {
        this.rowDataCondCliente = [];
      }
    );
  }

  eliminarCondCliente({ rowData }) {
    this._util
      .confirmarSincronoPromesa({
        title: 'Eliminar',
        action: 'Eliminar',
        funcion: this.promocionesService.borrarCondCliente(rowData),
      })
      .then((res: any) => {
        this.cargarCondCliente(this.idPromo);
      });
  }

  guardarCondCliente(payload: any) {
    payload.cantidad_maxima = payload.cantidad_maxima ? parseFloat(payload.cantidad_maxima) : 0;
    payload.control_maximo = payload.control_maximo ? parseFloat(payload.control_maximo) : 0;
    payload.numero_maximo_compras = payload.numero_maximo_compras ? parseFloat(payload.numero_maximo_compras) : 0;

    console.log("payload", payload);

    this._util
      .confirmarSincronoPromesa({
        title: '¿Esta seguro que desea procesar el siguiente formulario?',
        action: this.cliente ? 'Editar' : 'Nuevo',
        funcion: this.promocionesService.crearCondCliente(payload),
      })
      .then((res: any) => {
        this.cargarCondCliente(this.idPromo);
        this.verFormularioAgregarCondCliente = false;
      });
  }

  clienteSelected(cliente: Client) {
    this.clienteModal = cliente;
  }

  eliminarTodo() {
    this._util
      .confirmarSincronoPromesa({
        title: 'Eliminar',
        // text: `ID PROMO: ${rowData.id_promo}`,
        action: 'Eliminar',
        funcion: this.promocionesService.condClienteDeleteAll(this.idPromo),
      })
      .then((res: any) => {
        this.cargarCondCliente(this.idPromo);
      });
  }

}
